import * as devisConf from '@/configuration/devisConf';
import { ETAT_NON_RAPPROCHE_TYPE, ETAT_RAPPROCHE_TYPE, ETAT_RAPPROCHE_PARTIELLEMENT_TYPE } from '@/configuration/achat/bonReception/rapprochementConfig';

export default function getEtatTypeCommandeAchat(lieuxLivraison, etatCommande) {
  let etat = etatCommande;
  if (lieuxLivraison.every(l => l.etatRapprochement === ETAT_RAPPROCHE_TYPE)) {
    etat = devisConf.ETAT_RECEPTIONNEE;
  } else if (lieuxLivraison.some(l => l.etatRapprochement === ETAT_RAPPROCHE_PARTIELLEMENT_TYPE)) {
    etat = devisConf.ETAT_RECEPTIONNEE_PARTIELLEMENT;
  } else if (lieuxLivraison.every(l => l.etatRapprochement === ETAT_NON_RAPPROCHE_TYPE)) {
    etat = devisConf.ETAT_COMMANDE;
  }
  return etat;
}
